<template lang="html">
  <div id="header">
    <a class="logo" :href="$t('elfinbook_index')"></a>
    <div class="header-right">
      <div class="header__btn" @mouseenter="hover">{{ $t('Register') }}
        <div class="header__registerbox">
           <img class="header__qrcode" src="~@/assets/image/app.jpg">
           <div class="header__word">
             {{ $t('scan_download_app')}} <br/>
             {{ $t('resgister_in_app')}} 
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Ajax from '../utils/Ajax';
import { Message } from 'element-ui';

export default {
  props: {
    showUser: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      userinfo: {},
      cloudUsedPrecent: 0,
      isEn: /\/en\//.test(window.location.href)
    };
  },
  created() {
    console.log('version1.2');
    if (this.showUser) {
      try {
        let userinfo = JSON.parse(localStorage.getItem('userinfo'));
        if (userinfo && userinfo.headImg) {
          this.userinfo = userinfo;
        }
      } catch (error) {}
      this.getUserInfo();
      setInterval(() => {
        // 10分钟检测是否需要 弹出登录
        this.getUserInfo();
      }, 10 * 60000);
    }
  },
  methods: {
    hover() {
      window._report(`(登录)展开注册二维码`);
    },
    goHome() {
      location.href = !this.isEn
        ? '//www.elfinbook.com/'
        : '//www.elfinbook.com/en';
    },
    downloadApp() {
      location.href = !this.isEn ? '/download_app' : '/en/download_app';
    },
    getUserInfo() {
      return Ajax.get('/web/user').then((data) => {
        if (data.code == 0) {
          let d = data.data;
          d._cloudAll = parseInt(d.cloudSpaceSize / 1024 / 1024 / 8);
          d._cloudUsed = parseInt(d.usedSpaceSize / 1024 / 1024 / 8);
          d._levelname =
            d.level > 0 ? this.$t('Premium user') : this.$t('General user');
          this.cloudUsedPrecent = ((d._cloudUsed / d._cloudAll) * 100).toFixed(
            1
          );
          this.userinfo = d;
          localStorage.setItem('userinfo', JSON.stringify(d));
          this.$emit('userLogin');
        }
      });
    },
    extendCloud() {
      Message({
        type: 'error',
        message: this.$t('This feature is not yet available')
      });
    },
    logout() {
      return Ajax.post('/site/logout').then((d) => {
        localStorage.setItem('islogin', '');
        sessionStorage.setItem('isLogin', '');
        localStorage.setItem('userinfo', '');
        location.href = `./${this.isEn ? 'en' : 'cn'}/login`;
      });
    }
  }
};
</script>

<style lang="scss">
/* @import '../assets/scss/mixin.scss'; */

#header {
  height: 60px;
  background: #fafafa;
  z-index: 10;
}

.logo {
  width: 204px;
  height: 44px;
  float: left;
  margin-top: 10px;
  margin-left: 49px;
  background: url(../assets/image/general_navi_image_logo@2x.png) no-repeat 0 0 /204px
    44px;
}

.header-right {
  float: right;
  padding-right: 39px;
  padding-top: 14px;
}

.header__btn {
  cursor: pointer;
  height: 32px;
  line-height: 30px;
  border-radius: 4px;
  border: 1px solid rgba(186, 186, 186, 1);
  padding: 0 9px;
  position: relative;
  &:hover {
    .header__registerbox {
      display: block;
    }
  }
}
.header__registerbox {
  display: none;
  position: absolute;
  right: 0;
  top: 46px;
  width: 152px;
  height: 152px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.18);
  border-radius: 4px;
  text-align: center;
}
.header__qrcode {
  width: 90px;
  height: 90px;
  display: block;
  margin: 11px auto 5px;
}
.header__word {
  font-size: 12px;
  color: #666;
  line-height: 17px;
}
.page-en {
  .header__registerbox {
    height: 160px;
  }
}
</style>
